import React from 'react';
import styled from 'styled-components';

const StyledPicture = styled.picture`
  width: 100%;
  display: block;
  line-height: 0;
  font-size: 0;
  height: 600px;
  
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
    vertical-align: bottom;
  }

  @media (max-width: 599px) {
    height:100vw;
  }
`;

const CoverImage = ({ coverImage, mobileCoverImage, coverAlt, title }) => {
  return (
    <StyledPicture>
      <source media="(min-width: 600px)" srcSet={coverImage} />
      <source media="(max-width: 599px)" srcSet={mobileCoverImage} />
      <img src={coverImage} alt={coverAlt} title={title} />
    </StyledPicture>
  );
};

export default CoverImage;